import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  95% {
    color: inherit;
    text-shadow: inherit;
  }
  95.5%{
    color: #333;
  }
  96% {
    text-shadow: none;
  }
  97% {
    color: inherit;
    text-shadow: inherit;
  }
  98% {
    color: #333;
    text-shadow: none;
  }
  99% {
    color: inherit;
    text-shadow: inherit;
  }
  99.25% {
    color: #333;
    text-shadow: none;
  }
  99.5% {
    color: inherit;
    text-shadow: inherit;
  }
`;

export const Container = styled.section`
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 200px;
  min-width: 400px;
  max-width: 650px;
  padding: 16px;

  ${({ img, hasBackground }) =>
    hasBackground &&
    `
    background-image: linear-gradient(to bottom,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.2)
    ),url(${img});
    `}
`;
Container.displayName = 'Container';

export const Time = styled.div`
  font-family: 'Vibur', cursive;
  font-size: 70px;
  letter-spacing: 2px;
  line-height: 70px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  font-size: 40px;
  font-family: 'Vibur', cursive;
  letter-spacing: 2px;
  line-height: 40px;
  letter-spacing: 0px;
  margin-bottom: 24px;
  white-space: pre-wrap;
  > .blink {
    animation-name: ${blink};
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-duration: 8s;
  }
`;
Title.displayName = 'Title';
